import { Box, Typography } from "@mui/material";
import ReactHtmlParser from "@/src/utils/html-parser";
import Prose from "@/src/components/common/broadsheet/prose";
import SectionHeading from "@/src/components/common/broadsheet/section-heading";
import { FONT_TEXT } from "@/src/components/common/broadsheet/tokens";

const Index = ({ welcomeMsg }: { journal: Journal; welcomeMsg: any }) => (
  <Box component="section" aria-labelledby="journal-welcome-heading">
    <SectionHeading
      title="Welcome"
      titleId="journal-welcome-heading"
      component="h2"
    />
    <Box sx={{ pt: 0.75 }}>
      {welcomeMsg?.content ? (
        <Prose sx={{ fontSize: "0.9375rem" }}>
          {ReactHtmlParser(welcomeMsg.content)}
        </Prose>
      ) : (
        <Box sx={{ maxWidth: "70ch" }}>
          <Typography
            component="p"
            sx={{
              m: 0,
              mb: 0.75,
              fontFamily: FONT_TEXT,
              fontSize: "0.9375rem",
              lineHeight: 1.7,
              color: "custom.ink",
            }}
          >
            Dear Colleagues,
          </Typography>
          <Typography
            component="p"
            sx={{
              m: 0,
              mb: 0.75,
              fontFamily: FONT_TEXT,
              fontSize: "0.9375rem",
              lineHeight: 1.7,
              color: "custom.ink",
            }}
          >
            I, as the editor-in-chief, and on behalf of our editorial board
            would like to announce establishment of the current journal website.
            All papers in the field of journal are more than welcomed to our
            journal.
          </Typography>
          <Typography
            component="p"
            sx={{
              m: 0,
              fontFamily: FONT_TEXT,
              fontSize: "0.9375rem",
              lineHeight: 1.7,
              color: "custom.inkMuted",
            }}
          >
            Kind Regards,
            <br />
            Editor-in-chief
          </Typography>
        </Box>
      )}
    </Box>
  </Box>
);

export default Index;
